import { connect } from 'react-redux'
import SvgRight from '#/assets/images/icons/chevron-right.svg'
import { roleOrders } from '#/consts/plan'
import { currentRole, currentRoleWithShared } from '#/store/selectors/user'
import { commaNumber } from '#/utils/number'
import type { CardWithDetailProps } from '../../types'
import { Section } from '../common'
import PermitHistory from './PermitHistory'

type Props = CardWithDetailProps & {
  history?: TopHap.PropertyTransaction[]
  currentRole?: TopHap.UserRole
  forceUnlock?: boolean
  withAgentRole?: boolean
  disableSharedRole?: boolean
}

const Permits: React.FC<Props> = ({
  property,
  history,
  currentRole,
  forceUnlock,
  onDetail
}) => {
  if (!property.permitsCount) return null
  const permitsValue = property.permits?.reduce((total, permit) => total + permit.JobValue, 0)

  let isLocked = true
  if (forceUnlock === true) {
    isLocked = false
  }
  if (typeof currentRole !== 'undefined' && (roleOrders[currentRole] >= roleOrders['pro' as TopHap.UserRole])) {
    isLocked = false
  }

  return (
    <Section
      contentClassName='space-y-4 cursor-pointer bg-white px-5 py-3 h-[22rem] max-w-[40.75rem]'
      description={(
        <>
          {property.displayAddress} {' '} has {property.permitsCount ?? 0} permit records{permitsValue ? ` of total value of $${isLocked ? '---' : commaNumber(permitsValue)}` : ''}
          .
        </>
      )}
      id='permits'
      mode='Card'
      title='Permits'
      onClick={() => onDetail && onDetail('PermitHistory')}
    >
      <div className='flex items-center justify-between'>
        <div className='font-medium'>Permit History</div>
        <SvgRight className='h-3 w-3 text-brown-gray' />
      </div>
      <PermitHistory
        className='h-80 overflow-hidden'
        history={history}
        isLocked={isLocked}
        property={property}
      />
      <div className='pointer-events-none absolute inset-x-0 bottom-0 h-20 w-full bg-gradient-to-t from-white via-[#fffc]' />
    </Section>
  )
}

const mapStateToProps = (
  state: TopHap.StoreState,
  { disableSharedRole, withAgentRole }: { disableSharedRole?: boolean, withAgentRole?: boolean }
) => ({
  currentRole: disableSharedRole ?
    currentRole(state, withAgentRole) :
    currentRoleWithShared(state, withAgentRole),
  forceUnlock: false
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Permits)
